import { render, staticRenderFns } from "./UserAssetEmails.vue?vue&type=template&id=2987588a"
import script from "./UserAssetEmails.vue?vue&type=script&lang=js"
export * from "./UserAssetEmails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2987588a')) {
      api.createRecord('2987588a', component.options)
    } else {
      api.reload('2987588a', component.options)
    }
    module.hot.accept("./UserAssetEmails.vue?vue&type=template&id=2987588a", function () {
      api.rerender('2987588a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/assets/UserAssetEmails.vue"
export default component.exports